<router-outlet />
<!-- Error toasts when standalone; embedded, they go to HCP. Headless so the
close button does not take focus. -->
<p-toast [key]="errorToastKey">
  <ng-template #headless let-closeFn="closeFn" let-message>
    <div class="error-toast">
      <span
        aria-hidden="true"
        class="error-toast__icon material-symbols-outlined">
        error
      </span>
      <span class="error-toast__message">{{ message.detail }}</span>
      <button
        class="error-toast__close"
        type="button"
        [attr.aria-label]="'ERRORS.TOAST.CLOSE' | transloco"
        (click)="closeFn($event)">
        <span aria-hidden="true" class="material-symbols-outlined">close</span>
      </button>
    </div>
  </ng-template>
</p-toast>
